module.exports = __webpack_public_path__ + "img/thumb-video.8cd68171.jpg";